// extracted by mini-css-extract-plugin
export default {"addressButton":"AddressButton-module--addressButton--FotKF"};